'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by li on 2016/4/7.
                    */

// import { FooterCarousel } from 'components';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Footer, _Component);

  function Footer() {
    (0, _classCallCheck3.default)(this, Footer);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(Footer).call(this));

    _this.state = {
      footerCarouselImages: ['http://tupian.goeasy.cn:9999/yipinwang/ditu1.jpg', 'http://tupian.goeasy.cn:9999/yipinwang/ditu2.jpg', 'http://tupian.goeasy.cn:9999/yipinwang/ditu3.jpg', 'http://tupian.goeasy.cn:9999/yipinwang/ditu1.jpg', 'http://tupian.goeasy.cn:9999/yipinwang/ditu2.jpg', 'http://tupian.goeasy.cn:9999/yipinwang/ditu3.jpg'],
      friendLinks: {
        title: '友情链接',
        /*
         * 中国工艺美术协会  http://www.cnaca.org
         国资委            http://www.sasac.gov.cn/
         工信部            http://www.miit.gov.cn
         民政部            http://www.mca.gov.cn/
         中国社会组织网    http://www.chinanpo.gov.cn
         中国轻工业联合会  http://www.clii.com.cn/
         * */
        links: [{ txt: '中国工艺美术协会', ref: 'http://www.cnaca.org/index/index.html' }, { txt: '中国工艺集团公司设计院', ref: 'http://www.zhongyizhuangshi.com/homepage.jsp' }, { txt: '北京工艺美术出版社', ref: 'http://www.gmcbs.cn/' }, { txt: '国检中心', ref: 'http://www.ngtc.com.cn/' }, { txt: '国家编码中心', ref: 'http://www.ancc.org.cn/' }]
      },
      footerInfo: [{
        title: '工 • 定制',
        contents: [{ text: '雕塑艺品', url: '/customproductslist?productType=M0040390000000000000000001' }, { text: '金属艺品', url: '/customproductslist?productType=M0040390000000000000000002' }, { text: '漆器艺品', url: '/customproductslist?productType=M0040390000000000000000003' }, { text: '花画艺品', url: '/customproductslist?productType=M0040390000000000000000004' }, { text: '纤维编织', url: '/customproductslist?productType=M0040390000000000000000005' }, { text: '抽纱刺绣', url: '/customproductslist?productType=M0040390000000000000000006' }, { text: '地毯挂毯', url: '/customproductslist?productType=M0040390000000000000000007' }, { text: '珠宝首饰', url: '/customproductslist?productType=M0040390000000000000000008' }, { text: '民族工艺', url: '/customproductslist?productType=M0040390000000000000000009' }, { text: '陶瓷艺品', url: '/customproductslist?productType=M0040390000000000000000010' }, { text: '书画艺品', url: '/customproductslist?productType=M0040390000000000000000010' }]
      }, {
        title: '艺 • 艺品',
        contents: [{ text: '雕塑艺品', url: '/home?productType=M0040390000000000000000001' }, { text: '金属艺品', url: '/home?productType=M0040390000000000000000002' }, { text: '漆器艺品', url: '/home?productType=M0040390000000000000000003' }, { text: '花画艺品', url: '/home?productType=M0040390000000000000000004' }, { text: '纤维编织', url: '/home?productType=M0040390000000000000000005' }, { text: '抽纱刺绣', url: '/home?productType=M0040390000000000000000006' }, { text: '地毯挂毯', url: '/home?productType=M0040390000000000000000007' }, { text: '珠宝首饰', url: '/home?productType=M0040390000000000000000008' }, { text: '民族工艺', url: '/home?productType=M0040390000000000000000009' }, { text: '陶瓷艺品', url: '/home?productType=M0040390000000000000000010' }, { text: '书画艺品', url: '/home?productType=M0040390000000000000000011' }]
      }, {
        title: '美 • 服务',
        contents: [{ text: '艺品设计' }, { text: '艺品加工' }, { text: '艺品摄影' }, { text: '视觉设计' }, { text: '艺品鉴定' }, { text: '商业咨询' }, { text: '知识产权' }]
      }, {
        title: '术 • 百科',
        contents: [{ text: '行业头条' }, { text: '工美空间' }, { text: '工美百科' }]
      }],
      isQrCodeBoxShow: false
    };
    return _this;
  }

  (0, _createClass3.default)(Footer, [{
    key: 'onQrCodeBoxShow',
    value: function onQrCodeBoxShow() {
      this.setState({
        isQrCodeBoxShow: true
      });
    }
  }, {
    key: 'onQrCodeBoxClose',
    value: function onQrCodeBoxClose() {
      this.setState({
        isQrCodeBoxShow: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      // footerCarouselImages
      var _state = this.state;
      var footerInfo = _state.footerInfo;
      var friendLinks = _state.friendLinks;
      var isQrCodeBoxShow = _state.isQrCodeBoxShow;

      var styles = require('./Footer.scss');
      /* const {location} = this.props;
       let isYpwQcShow = false;
       if (location && location.pathname === '/') {
       isYpwQcShow = true;
       }
       console.log(isYpwQcShow); */
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.ewm_box2 },
          _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/footer/ewm_box.jpg',
            onMouseOver: this.onQrCodeBoxShow.bind(this), onMouseOut: this.onQrCodeBoxClose.bind(this), alt: '' }),
          _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/footer/ewm_img.jpg', className: styles.img,
            style: { display: isQrCodeBoxShow ? 'inline' : 'none' }, alt: '' })
        ),
        _react2.default.createElement(
          'div',
          { onClick: function onClick() {
              return window.scrollTo(0, 0);
            }, className: styles.backToTop, style: { marginTop: '20px' } },
          _react2.default.createElement('img', {
            src: 'http://tupian.goeasy.cn:9999/yipinwang/bai/top.jpg', alt: '' })
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.bot_a },
          _react2.default.createElement(
            'div',
            { className: 'float' },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/designer-4.png', alt: '', width: '100%' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'float ' + styles.tx + ' ml19' },
            '博览民族文化、交流工美技艺、尽情欣赏艺术、放心购买真品'
          ),
          _react2.default.createElement('div', { className: styles.bot_line + ' float' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bot_a + ' ml38' },
          _react2.default.createElement(
            'div',
            { className: 'float' },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/designer-3.png', alt: '', width: '100%' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'float ' + styles.tx + ' ml19' },
            '实名认证、动态密码身份、防伪'
          ),
          _react2.default.createElement('div', { className: styles.bot_line + ' float' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bot_a + ' ml38' },
          _react2.default.createElement(
            'div',
            { className: 'float' },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/designer-2.png', alt: '', width: '100%' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'float ' + styles.tx + ' ml19' },
            '资质认证、授牌、地址防伪校验、实体店体验'
          ),
          _react2.default.createElement('div', { className: styles.bot_line + ' float' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bot_a + ' ml38' },
          _react2.default.createElement(
            'div',
            { className: 'float' },
            _react2.default.createElement('img', {
              src: 'http://tupian.goeasy.cn:9999/yipinwang/designer-1.png', alt: '', width: '100%' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'float ' + styles.tx + ' ml19' },
            '国检鉴定、质检总局派发作品身份码、产品全生命周期大数据'
          ),
          _react2.default.createElement('div', { className: styles.bot_line + ' float' })
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bot_a + ' ml30' },
          _react2.default.createElement(
            'div',
            { className: 'float' },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/designer-5.png', alt: '',
              width: '100%' })
          ),
          _react2.default.createElement(
            'div',
            { className: 'float ' + styles.tx + ' ml19' },
            '对大师原作、工作室作品、机工、手工做明确标示'
          )
        ),
        _react2.default.createElement('div', { className: "clear" }),
        _react2.default.createElement(
          'div',
          { className: styles.ad },
          _react2.default.createElement(
            'div',
            { className: styles.ad_l },
            _react2.default.createElement(
              'div',
              { className: styles.tit },
              '网站地图'
            ),
            footerInfo.map(function (currentInfo, index) {
              return _react2.default.createElement(
                'div',
                { key: index },
                _react2.default.createElement(
                  'div',
                  { className: styles.tite },
                  currentInfo.title
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.txt_wh },
                  currentInfo.contents.map(function (currentContent, currentContentIndex) {
                    return _react2.default.createElement(
                      _reactRouter.Link,
                      { key: currentContentIndex,
                        to: currentContent.url || '/',
                        target: '_blank' },
                      currentContent.text
                    );
                  })
                )
              );
            })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.ad_r },
            _react2.default.createElement(
              'div',
              { className: styles.yl },
              _react2.default.createElement(
                'div',
                { className: styles.tit },
                friendLinks.title
              ),
              _react2.default.createElement(
                'div',
                { className: styles.txt },
                friendLinks.links.map(function (link, index) {
                  return _react2.default.createElement(
                    'a',
                    { key: index, href: link.ref, target: '_blank' },
                    link.txt
                  );
                })
              )
            ),
            _react2.default.createElement(
              _reactRouter.Link,
              { to: '/contactus/about', className: styles.lx },
              _react2.default.createElement(
                'div',
                { className: styles.tit },
                '联系我们'
              )
            ),
            _react2.default.createElement('div', { className: 'clear' }),
            _react2.default.createElement(
              'div',
              { className: styles.adr },
              '电信与信息服务业务经营许可证编号：京ICP备16017724号',
              _react2.default.createElement('br', null),
              '增值电信业务经营许可证编号：京B2-20171202',
              _react2.default.createElement('br', null),
              '公安机关备案号：11010602100319',
              _react2.default.createElement('br', null),
              '本站版权所有：中艺互联商务科技（北京）股份有限公司'
            )
          )
        )
      );
    }
  }]);
  return Footer;
}(_react.Component), _class.propTypes = {
  location: _react.PropTypes.object
}, _temp);
exports.default = Footer;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Footer/Footer.js
 ** module id = 1484
 ** module chunks = 0
 **/